<template>
  <div class="parent">
    <b-row>
      <b-col>
        <!-- Leaflet Map Component -->
        <div
          class="vx-card p-3"
          :style="isSmallerScreen ? `max-height: 88vh` : `max-height: 850px`"
        >
          <l-map
            class="map"
            ref="peta"
            :center.sync="map.center"
            :zoom="map.zoom"
            :options="mapOptions"
            :style="isSmallerScreen ? `max-height: 85vh` : `max-height: 750px`"
          >
            <!-- @zoomend="handleZoomEnd"
            style="max-height: 700px" -->

            <!-- @update:center="centerUpdate" -->
            <l-tile-layer
              v-for="tileProvider in tileProviders"
              :key="tileProvider.name"
              :name="tileProvider.name"
              :visible="tileProvider.visible"
              :url="tileProvider.url"
              :attribution="tileProvider.attribution"
              layer-type="base"
              :options="{ maxZoom: 22 }"
            />

            <l-polyline
              :lat-lngs="polyline.latlngs"
              :color="polyline.color"
              :weight="polyline.weight"
            ></l-polyline>

            <!-- <l-layer-group layerType="base" name="Sources" :visible="true">
              <l-polyline
                v-for="(item, index) in polyline2.color"
                :key="index"
                :lat-lngs="polyline2.latlngs[index]"
                :color="item"
                :weight="4"
              />
            </l-layer-group> -->

            <l-layer-group v-if="ritaseData.start_type == 1">
              <l-polygon
                :key="'start_poly'"
                :lat-lngs="ritaseData.start_latlngs"
                :visible="poiSwitch"
                color="green"
              >
                <l-tooltip
                  :options="{
                    permanent: true,
                    interactive: true,
                    direction: 'right'
                  }"
                  >{{ 'START POINT : ' + ritaseData.start_poi_name }}</l-tooltip
                >
              </l-polygon>
            </l-layer-group>
            <l-layer-group v-else>
              <l-marker
                :key="'start_point'"
                :lat-lng="ritaseData.start_latlngs"
                :visible="poiSwitch"
                :icon="ritaseData.start_icon"
              >
                <l-tooltip
                  :options="{
                    permanent: true,
                    interactive: true,
                    direction: 'right'
                  }"
                  >{{ 'START POINT : ' + ritaseData.start_poi_name }}</l-tooltip
                >
              </l-marker>
            </l-layer-group>

            <l-layer-group v-if="ritaseData.end_type == 1">
              <l-polygon
                :key="'end_poly'"
                :lat-lngs="ritaseData.end_latlngs"
                :visible="poiSwitch"
                color="grey"
              >
                <l-tooltip
                  :options="{
                    permanent: true,
                    interactive: true,
                    direction: 'right'
                  }"
                  >{{ 'END POINT : ' + ritaseData.end_poi_name }}</l-tooltip
                >
              </l-polygon>
            </l-layer-group>
            <l-layer-group v-else>
              <l-marker
                :key="'end_point'"
                :lat-lng="ritaseData.end_latlngs"
                :visible="poiSwitch"
                :icon="ritaseData.end_icon"
              >
                <l-tooltip
                  :options="{
                    permanent: true,
                    interactive: true,
                    direction: 'right'
                  }"
                  >{{ 'END POINT : ' + ritaseData.end_poi_name }}</l-tooltip
                >
              </l-marker>
            </l-layer-group>

            <l-control position="topleft">
              <b-card
                class="timeline-card"
                :style="isSmallerScreen ? 'width: 48vw;' : 'width: 300px;'"
                v-show="startSwitch"
              >
                <div class="timeline text-left">
                  <div class="timeline-wrapper">
                    <h5
                      style="font-weight: 600"
                      :style="isSmallerScreen ? 'font-size: 13px;' : ''"
                    >
                      Start Point
                    </h5>
                    <ul
                      class="timeline-sessions"
                      style="font-family: 'Poppins', sans-serif"
                    >
                      <li class="session-1">
                        <p class="session-content">
                          <template>
                            <div
                              class="session-title text-muted"
                              :style="isSmallerScreen ? 'font-size: 10px;' : ''"
                            >
                              IN POI
                            </div>
                            <span
                              class="session-subtitle d-block"
                              :style="isSmallerScreen ? 'font-size: 11px;' : ''"
                            >
                              {{ ritaseData.start_poi_name }}
                            </span>
                            <p
                              class="text-muted session-date"
                              :style="isSmallerScreen ? 'font-size: 10px;' : ''"
                            >
                              {{ ritaseData.start_in_poi_time }}
                            </p>
                          </template>
                        </p>
                      </li>
                      <li class="session-2">
                        <p class="session-content">
                          <template>
                            <div
                              class="session-title text-muted"
                              :style="isSmallerScreen ? 'font-size: 10px;' : ''"
                            >
                              OUT POI
                            </div>
                            <span
                              class="session-subtitle d-block"
                              :style="isSmallerScreen ? 'font-size: 11px;' : ''"
                            >
                              {{ ritaseData.start_poi_name }}
                            </span>
                            <p
                              class="text-muted session-date"
                              :style="isSmallerScreen ? 'font-size: 10px;' : ''"
                            >
                              {{ ritaseData.start_out_poi_time }}
                            </p>
                          </template>
                        </p>
                      </li>
                    </ul>
                  </div>
                  <template>
                    <h6 :style="isSmallerScreen ? 'font-size: 9px;' : ''">
                      {{ ritaseData.start_address }}
                    </h6>
                  </template>
                </div>
              </b-card>

              <b-card
                class="timeline-card mt-5"
                :style="isSmallerScreen ? 'width: 48vw;' : 'width: 300px;'"
                v-show="endSwitch"
              >
                <div class="timeline text-left">
                  <div class="timeline-wrapper">
                    <h5
                      style="font-weight: 600"
                      :style="isSmallerScreen ? 'font-size: 13px;' : ''"
                    >
                      End Point
                    </h5>
                    <ul
                      class="timeline-sessions"
                      style="font-family: 'Poppins', sans-serif"
                    >
                      <li class="session-1">
                        <p class="session-content">
                          <template>
                            <div
                              class="session-title text-muted"
                              :style="isSmallerScreen ? 'font-size: 10px;' : ''"
                            >
                              IN POI
                            </div>
                            <span
                              class="session-subtitle d-block"
                              :style="isSmallerScreen ? 'font-size: 11px;' : ''"
                            >
                              {{ ritaseData.end_poi_name }}
                            </span>
                            <p
                              class="text-muted session-date"
                              :style="isSmallerScreen ? 'font-size: 10px;' : ''"
                            >
                              {{ ritaseData.end_in_poi_time }}
                            </p>
                          </template>
                        </p>
                      </li>
                      <li class="session-2">
                        <p class="session-content">
                          <template>
                            <div
                              class="session-title text-muted"
                              :style="isSmallerScreen ? 'font-size: 10px;' : ''"
                            >
                              OUT POI
                            </div>
                            <span
                              class="session-subtitle d-block"
                              :style="isSmallerScreen ? 'font-size: 11px;' : ''"
                            >
                              {{ ritaseData.end_poi_name }}
                            </span>
                            <p
                              class="text-muted session-date"
                              :style="isSmallerScreen ? 'font-size: 10px;' : ''"
                            >
                              {{ ritaseData.end_out_poi_time }}
                            </p>
                          </template>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <template>
                  <h6 :style="isSmallerScreen ? 'font-size: 9px;' : ''">
                    {{ ritaseData.end_address }}
                  </h6>
                </template>
              </b-card>
            </l-control>

            <!-- SWITCH BUTTON WEB SCREEN -->
            <template v-if="!isSmallerScreen">
              <l-control position="topright" class="d-flex">
                <div
                  class="switch p-3"
                  style="font-family: 'Poppins', sans-serif"
                >
                  <vs-switch
                    v-model="poiSwitch"
                    color="#1da1f2"
                    class="switch-button"
                    name="switch-button"
                  />
                  <span>Show POI &nbsp;</span>
                </div>
                <div
                  class="switch p-3"
                  style="font-family: 'Poppins', sans-serif"
                >
                  <vs-switch
                    v-model="startSwitch"
                    color="#28C76F"
                    class="switch-button"
                    name="switch-button"
                  />
                  <span>Start Point</span>
                </div>
                <div
                  class="switch p-3"
                  style="font-family: 'Poppins', sans-serif"
                >
                  <vs-switch
                    v-model="endSwitch"
                    color="#626262"
                    class="switch-button"
                    name="switch-button"
                  />
                  <span>End Point &nbsp;</span>
                </div>
              </l-control>
            </template>

            <!-- SWITCH BUTTON MOBILE SCREEN -->
            <template v-else>
              <l-control position="topright" class="d-flex">
                <div
                  class="switch p-3"
                  style="font-family: 'Poppins', sans-serif; margin-right: -5px"
                >
                  <vs-switch
                    v-model="poiSwitch"
                    color="#1da1f2"
                    class="switch-button"
                    name="switch-button"
                  />
                  <span>POI &nbsp;</span>
                </div>
              </l-control>
              <l-control position="topright" class="d-flex">
                <div
                  class="switch p-3"
                  style="font-family: 'Poppins', sans-serif; margin-right: -5px"
                >
                  <vs-switch
                    v-model="startSwitch"
                    color="#28C76F"
                    class="switch-button"
                    name="switch-button"
                  />
                  <span>Start</span>
                </div>
              </l-control>
              <l-control position="topright" class="d-flex">
                <div
                  class="switch p-3"
                  style="font-family: 'Poppins', sans-serif; margin-right: -5px"
                >
                  <vs-switch
                    v-model="endSwitch"
                    color="#626262"
                    class="switch-button"
                    name="switch-button"
                  />
                  <span>End &nbsp;</span>
                </div>
              </l-control>
            </template>

            <l-control-layers position="bottomleft"></l-control-layers>

            <l-control-fullscreen
              position="bottomright"
              :options="{
                title: { false: 'Fullscreen', true: 'RegularScreen' }
              }"
            />

            <l-control-zoom
              position="bottomright"
              class="zoom-control"
            ></l-control-zoom>
          </l-map>
        </div>
      </b-col>

      <!-- Modal Lokasi Awal Detail -->
      <b-modal
        id="lokasi-awal-popup"
        modal-class="lokasi-awal-popup"
        header-class="lokasi-awal-header"
        header-text-variant="light"
        title="Start Point"
        hide-footer
        hide-header-close
        centered
      >
        <b-button
          class="close-modal-btn"
          @click="$bvModal.hide('lokasi-awal-popup')"
        >
          X
        </b-button>
        <div class="lokasi-awal-detail px-2">
          {{ data.start_address }}
        </div>
      </b-modal>

      <!-- Modal Lokasi Akhir Detail -->
      <b-modal
        id="lokasi-akhir-popup"
        modal-class="lokasi-akhir-popup"
        header-class="lokasi-akhir-header"
        header-text-variant="light"
        title="End Point"
        centered
        hide-footer
        hide-header-close
      >
        <b-button
          class="close-modal-btn"
          @click="$bvModal.hide('lokasi-akhir-popup')"
        >
          X
        </b-button>
        <div class="lokasi-akhir-detail px-2">
          {{ data.end_address }}
        </div>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import L from 'leaflet'
import {
  LMap,
  LTileLayer,
  LCircle,
  LControl,
  LControlZoom,
  LControlLayers,
  LLayerGroup,
  LPolyline,
  LMarker,
  LIcon,
  LPopup,
  LPolygon,
  LTooltip
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import LControlFullscreen from 'vue2-leaflet-fullscreen'
import LRotatedMarker from 'vue2-leaflet-rotatedmarker'
// import { latLngBounds, latLng } from 'leaflet'

import { Icon } from 'leaflet'
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

import {
  BBreadcrumb,
  BBreadcrumbItem,
  BCard,
  BCardTitle,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BFormDatepicker,
  BListGroup,
  BListGroupItem,
  BFormRadio,
  BBadge,
  BFormCheckbox,
  BModal,
  VBModal
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

export default {
  components: {
    LMap,
    LTileLayer,
    LCircle,
    LControl,
    LControlZoom,
    LControlLayers,
    LLayerGroup,
    LControlFullscreen,
    LPolyline,
    LPolygon,
    LTooltip,
    LMarker,
    LRotatedMarker,
    LLayerGroup,
    LIcon,
    LPopup,
    BBreadcrumb,
    BBreadcrumbItem,
    BCard,
    BCardTitle,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    vSelect,
    BFormDatepicker,
    flatPickr,
    BListGroup,
    BListGroupItem,
    BFormRadio,
    BBadge,
    BFormCheckbox,
    BModal
  },

  directives: {
    'b-modal': VBModal,
    Ripple
  },

  data() {
    return {
      url: 'https://www.google.com/maps/vt?lyrs=m@189&gl=en&x={x}&y={y}&z={z}',
      zoom: 15,
      center: [47.334852, -1.509485],
      centerUpdate: [],
      markerBergerak: L.latLng(-6.21011, 106.832459),

      map: {
        center: L.latLng(-6.21011, 106.832459),
        zoom: 12
      },

      mapOptions: {
        // zoomSnap: 0.5
        zoomControl: false
      },

      polyline: {
        latlngs: [],
        color: 'purple'
      },

      polyline2: {
        latlngs: [],
        color: []
      },

      poiSwitch: true,
      startSwitch: true,
      endSwitch: true,
      showElement: true,

      angleVehicle: '',

      data: [],
      token: '',

      // markerStart: {
      //   position: L.latLng(0, 0),
      //   icon: L.icon({
      //     iconUrl: require('@/assets/images/markers/start.png'),
      //     iconSize: [32, 32],
      //     iconAnchor: [16, 16]
      //   }),
      //   visible: false
      // },

      // markerFinish: {
      //   position: L.latLng(0, 0),
      //   icon: L.icon({
      //     iconUrl: require('@/assets/images/markers/finish.png'),
      //     iconSize: [32, 32],
      //     iconAnchor: [18, 26]
      //   }),
      //   visible: false
      // },

      tileProviders: [
        {
          name: 'Google Street',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=m@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Satellites',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Hybrid',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s,h@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Terrain',
          visible: true,
          url: 'https://www.google.com/maps/vt?lyrs=p@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Traffic',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=m@221097413,traffic&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          attribution:
            '&copy; <a target="_blank" href="https://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        }
      ],

      filter: {
        device: '',
        start_time: null,
        end_time: null
      },

      ritaseData: []
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.ritaseData = JSON.parse(localStorage.getItem('ritaseData'))

    this.filter.device = this.ritaseData.imei
    this.filter.start_time = this.ritaseData.start_in_poi_time
    this.filter.end_time = this.ritaseData.end_in_poi_time

    this.map.center = L.latLng(
      this.ritaseData.start_lat,
      this.ritaseData.start_lon
    )
    this.map.zoom = 18

    let start_latlngs =
      this.ritaseData.start_type == 1
        ? this.geomToPolygon(this.ritaseData.start_geom)
        : L.latLng(this.ritaseData.start_lat, this.ritaseData.start_lon)

    let end_latlngs =
      this.ritaseData.end_type == 1
        ? this.geomToPolygon(this.ritaseData.end_geom)
        : L.latLng(this.ritaseData.end_lat, this.ritaseData.end_lon)

    let start_icon =
      this.ritaseData.start_type == 0
        ? L.icon({
            iconUrl: `${this.ritaseData.start_fullpath_icon}`,
            iconSize: [50, 50]
          })
        : L.icon.Default

    let end_icon =
      this.ritaseData.end_type == 0
        ? L.icon({
            iconUrl: `${this.ritaseData.end_fullpath_icon}`,
            iconSize: [50, 50]
          })
        : L.icon.Default

    this.ritaseData = {
      ...this.ritaseData,
      start_latlngs: start_latlngs,
      end_latlngs: end_latlngs,
      start_icon: start_icon,
      end_icon: end_icon
    }
  },

  mounted() {
    this.initTable()
  },

  computed: {
    markerVehicle() {
      return L.icon({
        iconUrl: `${this.data.fullpath_icon.acc_on}`,
        iconSize: [50, 50]
      })
    },
    markerParking() {
      return L.icon({
        iconUrl: `${this.data.fullpath_icon.parking}`,
        iconSize: [50, 50]
      })
    },

    isSmallerScreen() {
      return this.$store.state.windowWidth < 992
    }
  },

  watch: {
    isSmallerScreen() {
      if (this.isSmallerScreen) {
        this.startSwitch = false
        this.endSwitch = false
      } else {
        this.startSwitch = true
        this.endSwitch = true
      }
    }
  },

  methods: {
    initTable() {
      // this.loading = true
      this.$http
        .get(`${this.$api.endpoint}/report/ritase_track`, {
          params: {
            device: this.filter.device,
            start: this.filter.start_time,
            end: this.filter.end_time
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          // this.loading = false
          // this.$vs.loading.close(`#btn-cari > .con-vs-loading`)

          let data_track = res.data.message.data
          data_track.map((item, i) => {
            let color = ''

            if (item.speed >= 0 && item.speed <= 30) {
              color = 'green'
            } else if (item.speed > 31 && item.speed <= 60) {
              color = 'blue'
            } else if (item.speed >= 61 && item.speed <= 100) {
              color = 'yellow'
            } else {
              color = 'red'
            }

            this.polyline.latlngs.push([item.lat, item.lon])

            if (i + 1 != data_track.length) {
              this.polyline2.latlngs.push([
                [item.lat, item.lon],
                [data_track[i + 1].lat, data_track[i + 1].lon]
              ])
              this.polyline2.color.push(color)
            }
          })
        })
        .catch((error) => {
          // this.loading = false
          // this.$vs.loading.close(`#btn-cari > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    latLngx(lat, lon) {
      return L.latLng(lat, lon)
    },

    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear(),
        hour = '' + d.getHours(),
        minute = '' + d.getMinutes(),
        second = '' + d.getSeconds()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      if (hour.length < 2) hour = '0' + hour
      if (minute.length < 2) minute = '0' + minute
      if (second.length < 2) second = '0' + second

      return (
        [year, month, day].join('-') + ' ' + [hour, minute, second].join(':')
      )
    },

    handleZoomEnd() {
      if (this.poiSwitch && this.alertSwitch) {
        this.$nextTick(() => {
          this.$refs.peta.mapObject.eachLayer((layer) => {
            if (layer instanceof L.Marker) {
              layer.setLatLng(layer.getLatLng())
            }
          })
        })
      }
    },

    convertSecToMin(second) {
      const minute = Math.floor(second / 60)
      return minute + ' Menit'
    },

    centerMap(item, icon) {
      const newZoom = 19
      this.$refs.peta.mapObject.setView(L.latLng(item.lat, item.lon), newZoom)
      // this.$refs.peta.mapObject.panTo(L.latLng(item.lat, item.lon))

      this.showElement = false
      const marker = this.$refs.vehicle.mapObject
      const newLatlng = [item.lat, item.lon]
      marker.setLatLng(newLatlng)
      this.centerUpdate = newLatlng

      this.angleVehicle = item.angle
      this.markerx = icon
        ? L.icon({
            iconUrl: `${icon.acc_on}`,
            iconSize: [50, 50]
          })
        : L.icon.Default
    },

    geomToPolygon(geom) {
      let start = '(('
      let end = '))'

      geom = geom.substring(
        geom.indexOf(start) + start.length,
        geom.indexOf(end)
      )

      let latlon = geom.split(',')

      let result = []
      latlon.map((item) => {
        let x = item.split(' ')
        result.push([parseFloat(x[1]), parseFloat(x[0])])
      })

      return result
    }
  }
}
</script>

<style>
/* .leaflet-container .leaflet-marker-pane img {
  transition: 1000ms linear;
} */

.rotated-marker {
  transition: 1000ms linear;
}

.lokasi-awal-popup .modal-content {
  border: none;
}

.lokasi-awal-popup .lokasi-awal-header {
  background-color: #28c76f;
}

.lokasi-awal-popup h5 {
  color: #fff;
}

#lokasi-awal-popup .close-modal-btn {
  position: absolute;
  top: -62px;
  right: -9px;
  background-color: #fff;
  color: #4b465c;
  font-weight: 800;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  border-radius: 6px;
  border: none;
}

#lokasi-awal-popup .close-modal-btn:hover {
  background-color: #e6e6e6;
}

.lokasi-akhir-popup .modal-content {
  border: none;
}

.lokasi-akhir-popup .lokasi-akhir-header {
  background-color: #ea5455;
}

.lokasi-akhir-popup h5 {
  color: #fff;
}

#lokasi-akhir-popup .close-modal-btn {
  position: absolute;
  top: -62px;
  right: -9px;
  background-color: #fff;
  color: #4b465c;
  font-weight: 800;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  border-radius: 6px;
  border: none;
}

#lokasi-akhir-popup .close-modal-btn:hover {
  background-color: #e6e6e6;
}
</style>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

.vue2leaflet-map {
  &.leaflet-container {
    // height: 550px;
    height: 75em;
  }
}

.parent {
  font-family: 'Poppins', sans-serif;
}
.date-input-card,
.list-card,
.map-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
}

// Date Input CSS

.date-input {
  font-weight: 600;
}

.date-input .date-picker {
  background-color: white;
  cursor: pointer;
}

.date-input .start-time,
.end-time {
  border: 1px solid #b0b0b0;
  border-radius: 4px;
  background-color: #f8f8f8;
  opacity: 1;
  font-weight: 400;
}

.date-input #btn-cari {
  background-color: #28c76f;
  border: none;
  border-radius: 6px;
  font-weight: 500;
}

.date-input #btn-cari:hover {
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
}

// Leaflet Map CSS
.timeline .session-content a,
.timeline .session-content a:hover {
  color: #1da1f2;
  text-decoration: underline;
}

.map .switch {
  margin-inline: 10px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.map .switch span {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 13px;
}

.map .switch .switch-button {
  border-radius: 25px;
}

.map .control {
  background-color: #fff;
  border-radius: 5px;
  display: flex;
  margin: 10px 0;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
}

[dir] .leaflet-touch .leaflet-control-layers,
[dir] .leaflet-touch .leaflet-bar {
  border: none;
  box-shadow: 0px 2px 4px rgba(91, 91, 94, 0.3);
}

[dir] .leaflet-touch .leaflet-control-layers {
  font-size: 10px;
}

// List Status CSS

.list-card {
  height: 65em;
}

.list-card .list-item-title {
  border: none;
  border-bottom: 1px solid #1da1f2;
  border-radius: 12px;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
}

.list-card .list-item-title h5 {
  font-weight: 700;
  font-size: 16px;
}

.list-container {
  overflow-y: scroll;
  // height: 100px;
}

.list-item h5 {
  font-weight: 600;
  font-size: 15px;
}

.list-item p {
  font-weight: 400;
  font-size: 13px;
}

.list-item .badge {
  width: 80px;
  height: 22px;
  padding: 0 10px;
  background-color: #28c76f;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  border-radius: 5px;

  &:before {
    content: url('~@/assets/images/tabler-icon/edited/flag-white.svg');
    margin-right: 5px;
  }
}

.list-item .badge-moving {
  width: 80px;
  height: 22px;
  padding: 0 10px;
  background-color: #1da1f2;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  border-radius: 5px;
}

.list-item .badge-stop {
  width: 80px;
  height: 22px;
  padding: 0 10px;
  background-color: #4b465c;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  border-radius: 5px;
}

.list-item .badge-alarm {
  width: 80px;
  height: 22px;
  padding: 0 10px;
  background-color: #db4437;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  border-radius: 5px;
}

// Timeline CSS Component
.timeline-card {
  width: 300px;
  box-shadow: 2px 2px 4px rgba(165, 163, 174, 0.6);
  border-radius: 8px;
}

.timeline ul,
.timeline li {
  list-style: none;
  padding: 0;
}

.timeline .timeline-sessions {
  position: relative;
}

.timeline .session-title {
  font-weight: 400;
  font-size: 0.929rem;
}

.timeline .session-content {
  font-weight: 600;
  font-size: 1.071rem;
}

.timeline .session-date {
  font-weight: 400;
  font-size: 0.929rem;
}

.timeline .session-date.date-parking {
  font-weight: 600;
  font-size: 0.929rem;
}

.timeline li.session-1 {
  padding-bottom: 0.5rem;
  border-left: 1px dashed #4b465c;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;

  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }

  &:before {
    content: '';
    width: 15px;
    height: 15px;
    background: #28c76f;
    box-shadow: 0px 0px 0px 4px rgba(0, 209, 232, 0.2);
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}

.timeline li.session-2 {
  padding-bottom: 1.5rem;
  border-left: 1px dashed #4b465c;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;

  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }

  &:before {
    content: '';
    width: 15px;
    height: 15px;
    background: #db4437;
    box-shadow: 0px 0px 0px 4px rgba(75, 70, 92, 0.1);
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}

.timeline li.session-3 {
  padding-bottom: 1.5rem;
  border-left: 1px dashed #4b465c;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;

  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }

  &:before {
    content: '';
    width: 15px;
    height: 15px;
    background: #ff9f43;
    box-shadow: 0px 0px 0px 4px rgba(255, 159, 67, 0.1);
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}

.timeline li.session-4 {
  padding-bottom: 1.5rem;
  border-left: 1px dashed #4b465c;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;

  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }

  &:before {
    width: 15px;
    height: 15px;
    background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0.5),
        rgba(255, 255, 255, 0.5)
      ),
      #4b465c;
    box-shadow: 0px 0px 0px 4px rgba(75, 70, 92, 0.1);
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}
</style>
